<template>
  <v-footer class="footer-compact">
    <v-row class="justify-center" gap="16">
      <v-col class="text-right text-footer" cols="6">
        <nuxt-link target="_blank" to="/data-privacy/">Data Privacy</nuxt-link>
      </v-col>
      <v-col class="text-left text-footer" cols="6">
        <a target="_blank" href="https://www.syslifters.com/en/imprint">Imprint</a>
      </v-col>
    </v-row>
  </v-footer>
</template>

<style lang="scss" scoped>
@use '@/assets/vuetify.scss' as vuetify;

.footer-compact {
  max-height: 2rem;
  height: 2rem !important;
  padding: 0;
  border-top: 1px solid color-mix(in srgb, rgb(var(--v-border-color)) calc(var(--v-border-opacity) * 100%), transparent);

  &:deep() {
    .v-row {
      margin: 0;
    }
    .v-col {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

.text-footer {
  font-size: 0.75rem !important;
}
.text-footer a {
  color: inherit;
  opacity: 0.7;
  font-style: italic;
  text-decoration: none;
}
</style>
